export default __webpack_public_path__ + "static/media/vietnamese_iced_coffee.0fd79fcf.JPG";